import { ApiQueryConfig } from 'api/types';
import { createApiEndpoint } from 'api/utils';
import { URLS } from 'config';

type Timezone = { Name: string; ID: string };
type GetTimezonesConfig = ApiQueryConfig<Timezone[]>;

const url = `${URLS.app}/api/Date`;

export const getTimezones = createApiEndpoint<GetTimezonesConfig>({
  url,
  method: 'GET',
});
